<template>
  <view>
    <view>通过默认slot 传入展开、收起的内容</view>
    <view class="bg-white">
      <cube-collapse>
        <view>内容文案，第一行</view>
        <view>内容文案，第二行</view>
        <view>内容文案，第三行</view>
        <view>内容文案，第四行</view>
      </cube-collapse>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({})
</script>

<style lang="stylus" scoped>
.bg-white
  margin-top: 6px
  background-color: #fff
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-collapse": "@mpxjs/mpx-cube-ui/src/components/collapse/index"
    }
  }
</script>
